module.exports = __webpack_public_path__ + "static/media/Buvidal Weekly Product Information.a3ebb6d8.pdf";